import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=4fe0b0a3&scoped=true&"
import script from "./PurchaseCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PurchaseCard.vue?vue&type=style&index=1&id=4fe0b0a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0b0a3",
  null
  
)

export default component.exports